import React from "react";
import "./QueryAnswerEvidenceStrip.css";

/**
 * Compact always-visible evidence summary for Query Repository answers.
 */
export default function QueryAnswerEvidenceStrip({ metadata }) {
  if (!metadata) return null;

  const sections = metadata.answerSections;
  const relevantFiles =
    sections?.evidenceSummary?.relevantFiles?.map((f) => f.filePath).filter(Boolean) ??
    metadata.relevantFiles ??
    [];
  const whatNext = sections?.whatToCheckNext ?? [];
  const limitations = [];
  if (metadata.weakContextReason) limitations.push(metadata.weakContextReason);
  if (Array.isArray(sections?.knownLimitations)) {
    for (const lim of sections.knownLimitations) {
      if (typeof lim === "string" && lim.trim()) limitations.push(lim.trim());
    }
  }

  const hasContent =
    metadata.confidence ||
    relevantFiles.length > 0 ||
    whatNext.length > 0 ||
    limitations.length > 0;

  if (!hasContent) return null;

  return (
    <div className="query-answer-evidence-strip" aria-label="Repository answer evidence">
      {metadata.confidence && (
        <div className="qaes-row">
          <span className="qaes-label">Confidence</span>
          <span className={`qaes-confidence qaes-confidence-${String(metadata.confidence).toLowerCase()}`}>
            {metadata.confidence}
          </span>
        </div>
      )}

      {relevantFiles.length > 0 && (
        <div className="qaes-row">
          <span className="qaes-label">Relevant files</span>
          <ul className="qaes-file-list">
            {relevantFiles.slice(0, 5).map((file, i) => (
              <li key={i}><code>{file}</code></li>
            ))}
            {relevantFiles.length > 5 && (
              <li className="qaes-more">+{relevantFiles.length - 5} more in analysis details</li>
            )}
          </ul>
        </div>
      )}

      {whatNext.length > 0 && (
        <div className="qaes-row">
          <span className="qaes-label">What to inspect next</span>
          <ul className="qaes-next-list">
            {whatNext.slice(0, 3).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {limitations.length > 0 && (
        <div className="qaes-row qaes-limitations">
          <span className="qaes-label">Limitations</span>
          <span>{limitations.slice(0, 2).join(" · ")}</span>
        </div>
      )}
    </div>
  );
}
